// @flow

export const throttlingLoad = (domainId: number) => ({
    type: 'THROTTLING_LOAD',
    payload: { domainId },
});

export const throttlingLoaded = (domainId: number, snapshot: Object) => ({
    type: 'THROTTLING_LOADED',
    payload: { domainId, snapshot },
});

export const throttlingFailed = (domainId: number, error: Object) => ({
    type: 'THROTTLING_FAILED',
    payload: { domainId, error },
});

export const throttlingStop = (domainId: number) => ({
    type: 'THROTTLING_STOP',
    payload: { domainId },
});
